const initialState = { type: "", id: 0 }

const taskRowReducer = (dialog = initialState, action) => {
    return action.type ? action : initialState
}

export default taskRowReducer;